import * as React from "react";
// Remember that all const are suffix _svg

const sync_svg = (
  <svg
    version="1.1"
    id="Capa_1"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 512 512"
    xmlSpace="preserve"
    className={"a-sync"}
    style={{ width: "18px" }}
  >
    <path
      fill="white"
      d="M370.7,133.3C339.5,104,298.9,88,255.8,88C178.3,88.1,111.5,141.2,93,214.9c-1.3,5.4-6.1,9.1-11.7,9.1H24.1
	c-7.5,0-13.2-6.8-11.8-14.2C33.9,94.9,134.8,8,256,8c66.4,0,126.8,26.1,171.3,68.7L463,41c15.1-15.1,41-4.4,41,17v134
	c0,13.3-10.7,24-24,24H345.9c-21.4,0-32.1-25.9-17-41L370.7,133.3z M32,296h134.1c21.4,0,32.1,25.9,17,41l-41.8,41.8
	C172.5,408,213.1,424,256.2,424c77.4-0.1,144.3-53.1,162.8-126.8c1.3-5.4,6.1-9.1,11.7-9.1H488c7.5,0,13.2,6.8,11.8,14.2
	C478.1,417.1,377.2,504,256,504c-66.4,0-126.8-26.1-171.3-68.7L49,471c-15.1,15.1-41,4.4-41-17V320C8,306.7,18.7,296,32,296z"
    />
  </svg>
);

export { sync_svg };
